import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { IFootNote } from '../../_interfaces/footnote.interface';
import { SdSkeletonComponent } from '../skeleton/skeleton.component';
import { SkeletonAppearanceEnum } from '../../_enums/skeleton.enum';
import { BrandThemesEnum, ThemesEnum } from '../../_enums/themes.enum';
import { PositionEnum } from '../../_enums/position.enum';
import { SdThemeComponent } from '../abstract/theme/theme.component';
import { SizesEnum } from '../../_enums/sizes.enum';
import { ThemesTextEnum } from '../../_enums/themes-text.enum';
import { ThemesUtils } from '../../utils/themes.utils';
import { SdHtmlComponent } from '../html/html.component';

@Component({
  selector: 'sd-footnote',
  templateUrl: './footnote.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdSkeletonComponent,
    TranslateModule,
    SdHtmlComponent
  ]
})
export class SdFootnoteComponent extends SdThemeComponent implements OnChanges {
  @Input()
  isLoading = false;

  @Input()
  footNotes: IFootNote[];

  @Input()
  parentsThemesConfig: ThemesEnum | BrandThemesEnum;

  @Input()
  textConfig: PositionEnum.left | PositionEnum.right | PositionEnum.center =
    PositionEnum.left;

  @Input()
  isSmall = false;

  @Input() class = ''; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.contentThemesConfig && this.parentsThemesConfig
        ? 'is-theme-' + this.contentThemesConfig
        : '',
      this.textConfig ? 'is-' + this.textConfig + '-aligned' : '',
      this.isSmall ? 'is-small' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  manageThemesTextConfigUtils = ThemesUtils.manageThemesTextConfig;
  contentThemesConfig: ThemesTextEnum;
  skeletonAppearanceEnum = SkeletonAppearanceEnum;
  sizesEnum = SizesEnum;

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    this.manageThemesTextConfig(this.parentsThemesConfig);
  }

  manageThemesTextConfig(theme: ThemesEnum | BrandThemesEnum) {
    this.contentThemesConfig = this.manageThemesTextConfigUtils(theme);
  }
}
